import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-preview-final-report-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './preview-final-report-modal.component.html',
  styleUrl: './preview-final-report-modal.component.scss',
})
export class PreviewFinalReportModalComponent {
  constructor(private translateService: TranslateService) {}

  @Input() previewReportErrorText: string = '';
}
